import { connect, FieldArray, Field as FormikField } from 'formik'
import { NOMINATION_DTSP_FIELDS } from '@/entity/nomination'
import cl from 'classnames'
import { Button, Field } from '@/ui'
import styles from './Modal.style.scss'
import { Delete } from '@app/icons'
import { Plus } from '@app/images'
import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getCurrentLanguage } from '@/i18next'
import { nominationThunks } from '@/entity/nomination'

let initialState = {
	orgBin: null,
	place: null,
}

export const CategoryArrayField = connect(({
																						 name,
																						 item,
																						 formik: { setFieldValue, values, errors },
																					 }) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const lang = getCurrentLanguage()
	const [array, setArray] = useState([])

	useEffect(() => {
		setFieldValue(name, [initialState, initialState, initialState])
	}, [])

	const { dtspReqsList } = useSelector((state) => ({
		dtspReqsList: state.nomination.dtspReqsList,
	}))

	useEffect(() => {
		let body = {
			data: {
				nominationCode: item.nominationCode,
				year: parseInt(item.year),
				katoAB: item.katoAB?.substring(0, 2),
				searchText: item.searchText,
				subjectCategoryCodes: item.subjectCategoryCodes,
			},
			onSuccess: (res) => {
				let arr = res?.map(i => ({
					code: i.bin,
					nameRu: i.orgName,
					nameKz: i.orgName,
				}))
				setArray(arr)
			}
		}
		dispatch(nominationThunks.setDtspReqsList(body))
	}, [])

	let filtered = useMemo(() => {
		let arr = values[name]?.map(i => i.orgBin)
		let filtered = array?.filter(i => !arr.includes(i.code))
		return filtered
	}, [values, array])

	return (
		<FieldArray name={name}>
			{({ form: { values }, push, remove, ...props }) => {
				return (
					<div>
						{values[name]?.map((i, idx) => {
							return (
								<div key={idx + 1} className={cl('flex', 'align-items-center', 'gap-4')}>
									<span>
										{t('nomination.place', { place: idx + 1 })}
									</span>

									<div className={cl('flex-1')}>
										<FormikField name={`${name}.[${idx}].${NOMINATION_DTSP_FIELDS.orgBin}`}>
											{({ field, meta: { touched, error } }) => {
												return (
													<Field
														fieldType={'selectSearch'}
														placeholder={t('choose_from_directory')}
														options={field.value ? array : filtered}
														error={touched && error}
														{...field}
													/>
												)
											}}
										</FormikField>
									</div>

									{values[name]?.length > 1 && (
										<Button
											type="bare"
											onClick={() => remove(idx)}
											buttonClassName={cl(styles.buttonRed, 'mt-0')}
										>
											<Delete />
											<span className="ms-2">{t('remove')}</span>
										</Button>
									)}
								</div>
							)
						})}

						<div className={cl('mt-5')}>
							<Button
								textColor="green"
								borderColor="green"
								transparent
								border
								type="button"
								icon={Plus}
								onClick={() => push(initialState)}
								buttonClassName={cl(styles.button, 'mt-0')}
							>
								{t('nomination.add_place')}
							</Button>
						</div>
					</div>
				)
			}}
		</FieldArray>
	)
})